import React from 'react';
import { usePermissions, Permission } from '@/contexts/PermissionsContext';

interface TableButtonProps {
  permission: Permission;
  onClick: (e: React.MouseEvent) => void;
  icon: React.ReactNode;
  label: string;
  variant?: 'primary' | 'danger' | 'secondary';
  disabled?: boolean;
  fixedWidth?: boolean;
}

export const TableButton: React.FC<TableButtonProps> = ({
  permission,
  onClick,
  icon,
  label,
  variant = 'primary',
  disabled = false,
  fixedWidth = false,
}) => {
  const { hasPermission } = usePermissions();

  if (!hasPermission(permission)) {
    return null;
  }

  const baseClasses = `px-3 py-1 rounded-md transition-colors duration-200 sentence-case flex items-center gap-1 ${
    fixedWidth ? 'w-28 justify-center' : ''
  }`;

  const variantClasses = {
    primary:
      'bg-brand-white text-brand-orange border border-brand-orange hover:bg-brand-orange hover:text-brand-white',
    danger:
      'bg-brand-white text-red-600 border border-red-600 hover:bg-red-600 hover:text-brand-white',
    secondary:
      'bg-brand-white text-gray-600 border border-gray-600 hover:bg-gray-600 hover:text-brand-white',
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variantClasses[variant]} ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      }`}
    >
      {icon}
      {label}
    </button>
  );
};
